import Button from "@components/Button/Button";
import ButtonFactory from "@components/Button/ButtonFactory";
import { ButtonType } from "@components/Button/utils/types";
import { getKeywordLink } from "@components/FollowKeyword/helper";
import { cn, getUrlQuery } from "@util/helpers";

import {
  IndividualKeywordType,
  KeywordType,
  KeywordTypeFactoryProps,
} from "./utils/types";

const commonClasses =
  "line-clamp-1 place-self-center break-all px-3 text-center font-poppins text-base font-semibold capitalize";

const KeywordWithTag = ({
  tag,
  tagDisplayName,
  refCode,
  tagClassName,
}: IndividualKeywordType) => {
  const link = getKeywordLink(tag);
  const linkParams = new URLSearchParams(refCode ? { ref: refCode } : {});
  const _link = link + getUrlQuery(link, linkParams);

  return (
    <ButtonFactory
      buttonType={ButtonType.Link}
      link={_link}
      text={tagDisplayName}
      className={tagClassName}
    />
  );
};

const KeywordListing = ({
  tagDisplayName,
  tagClassName,
}: IndividualKeywordType) => {
  return <h1 className={cn(commonClasses, tagClassName)}>{tagDisplayName}</h1>;
};

const KeywordNoTag = ({
  tagDisplayName,
  tagClassName,
  handleClick,
  disableBorder,
}: IndividualKeywordType) => {
  return (
    <Button
      onClick={handleClick}
      className={cn(
        commonClasses,
        { "mr-3 border-r border-gray-450": !disableBorder },
        tagClassName
      )}
    >
      {tagDisplayName}
    </Button>
  );
};

export const KeywordFilterFactory = ({
  keywordType = KeywordType.default,
  tagDisplayName = "",
  handleClick,
  disableBorder,
  tagClassName,
  tag,
  refCode,
}: KeywordTypeFactoryProps) => {
  const props = {
    tagDisplayName,
    disableBorder,
    tagClassName,
    tag,
    refCode,
  };

  switch (keywordType) {
    case KeywordType.withTag:
      return <KeywordWithTag {...props} />;

    case KeywordType.listing:
      return <KeywordListing {...props} />;

    case KeywordType.noTag:
      return <></>;

    case KeywordType.default:
    default:
      return <KeywordNoTag handleClick={handleClick} {...props} />;
  }
};
